import { Box, Rating, Tooltip } from '@mui/material'
import type { IconContainerProps } from '@mui/material'
import type { SkillRating } from '../../../types/skills'

interface SkillRatingStarsProps {
  rating: SkillRating | null
  onChange: (rating: SkillRating | null) => void
  tooltips?: string[] // 6段階分のツールチップ配列（[0]=E, [1]=D, ..., [5]=S）
}

// デフォルトツールチップ（スキルレベルのみ）
const DEFAULT_TOOLTIPS = [
  'E: 経験なし',
  'D: 基礎レベル',
  'C: 実践レベル',
  'B: 応用レベル',
  'A: 熟練レベル',
  'S: エキスパートレベル',
]

export function SkillRatingStars({ rating, onChange, tooltips = DEFAULT_TOOLTIPS }: SkillRatingStarsProps) {
  const ratingLetters = ['E', 'D', 'C', 'B', 'A', 'S']

  const handleChange = (_event: React.SyntheticEvent, newValue: number | null) => {
    onChange(newValue as SkillRating | null)
  }

  // カスタムアイコンコンテナコンポーネント（新しいslots API用）
  function CustomIconContainer(props: IconContainerProps) {
    const { value, children, ...other } = props
    const tooltipText = tooltips[value - 1] || DEFAULT_TOOLTIPS[value - 1]

    return (
      <Tooltip title={tooltipText} placement="top" arrow>
        <span {...other}>{children}</span>
      </Tooltip>
    )
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <Box sx={{ fontSize: '0.75rem', fontWeight: 'bold', minWidth: '15px', color: '#666' }}>
        {rating !== null ? ratingLetters[rating - 1] : ''}
      </Box>
      <Rating
        value={rating}
        max={6}
        onChange={handleChange}
        slots={{
          icon: CustomIconContainer,
        }}
        sx={{
          flexDirection: 'row',
          '& .MuiRating-icon': {
            color: '#f4b400',
          },
          '& .MuiRating-iconEmpty': {
            color: '#ccc',
          },
        }}
      />
    </Box>
  )
}
